import React, {useState, useEffect} from "react";
import { Alert } from "react-bootstrap";
import { Button, ButtonToolbar, Input, ButtonGroup, Form, Spinner, Modal, InputGroup } from 'react-bootstrap';

import './ticks.css';
import AddTick from "../Forms/AddTick";

const Ticks = props => {
    const route = props.route;
    const routeID = route.id;
    const type = route.type;
    const grade = route.grade;
    const ticks = props.ticks;
    const userID = props.userID;
    const pointMeta = route.points;
    const feet = route.feet;

    

    const [tick,setTick] = useState(0);
    const pointTotal = Number(ticks)*Number(pointMeta)
    const [points,setPoints] = useState(Number(ticks)*Number(pointMeta));
    const [addTickLoading, setAddTickLoading] = useState(false);
    const [deleteTickLoading, setDeleteTickLoading] = useState(false);

    

    useEffect(()=>{
        console.log('change')
        if(ticks=='2'){
            setAddButton(true)
            setDeleteButton(false)
        }
        if(ticks=='0'){
            setDeleteButton(true);
        }
        if(ticks==undefined){
            setPoints('0')
            setDeleteButton(true);
        } else {
            setTick(ticks)
            setPoints(pointTotal)
            setDeleteButton(false)
        }
    },[ticks,pointTotal])

    

    const pointValue = 400;

    const [value, setValue] = useState('Redpoint');
    const [addButton,setAddButton] = useState(false);
    const [deleteButton, setDeleteButton] = useState(false);


    const [show, setShow] = useState(false);
    const [showDelete,setShowDelete] = useState(false);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseDelete = () => setShowDelete(false);
    const handleShowDelete = () => setShowDelete(true);



    
    const handleChange = async (event) => {
        setValue(event.target.value)
    }
    

    const addTick = async () => {
        setAddTickLoading(true);


        const addNewtick = await fetch('https://settersbloc.com/api/upallnight_add_tick.php',{
            method: 'POST',
            body: JSON.stringify({
            user: userID,
            id: routeID,
            type: type, 
            grade: grade,
            feet: feet,
            points: pointMeta,
            style:value
            })
        })
        .then(result => result.text())
        .then((result)=>{
            console.log(result)
            setTick(result);
            
            setPoints(result*pointMeta)
            setShow(false);
            setAddTickLoading(false);
            if(result=='2'){
                setAddButton(true);
            }
            if(result=='1'){
                setDeleteButton(false);
            }
        })
        
        
    }
    const deleteTick = async () => {
        setDeleteTickLoading(true);


        const deleteNewtick = await fetch('https://settersbloc.com/api/upallnight_delete_tick.php',{
            method: 'POST',
            body: JSON.stringify({
            user: userID,
            id: routeID,
            type: type, 
            grade: grade,
            feet: feet,
            points: pointMeta,
            style:value
            })
        })
        .then(result => result.text())
        .then((result)=>{
            
            setTick(result);
            
            setPoints(result*pointMeta)
            setShowDelete(false);
            setDeleteTickLoading(false);
            if(result=='0'){
                setAddButton(false);
                setDeleteButton(true);
            }
            if(result=='1'){
                setAddButton(false);
                setDeleteButton(false);
            }
        })
        
        
    }


    return(
        <div>
        <div className='ticks'>
                
                <ButtonToolbar className="mb-3" aria-label="Toolbar with Button groups">
                    <ButtonGroup className="me-2" aria-label="blagroup">
                        <Button disabled={addButton} onClick={handleShow} variant="primary">
                            +
                        </Button>
                        <Button disabled='true' variant="dark">
                            {tick} Tick(s)
                        </Button>
                        <Button disabled={deleteButton} onClick={handleShowDelete} variant="primary">
                            -
                        </Button>
                        <Button disabled variant="danger">
                            {points} Points
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            
        </div>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add Tick</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form> 
            <Form.Group >
                <InputGroup className="mb-2">
                    <InputGroup.Prepend>
                        <InputGroup.Text>Tick</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control as="select" onChange={handleChange}>
                        <option value="Redpoint">Redpoint</option>
                        <option value="Onsight">Onsight</option>
                    </Form.Control>
                </InputGroup>
                </Form.Group>
                <Button variant="primary" disabled={addTickLoading} onClick={addTick}>
                    Add Tick
                </Button>
                </Form>
            </Modal.Body>
        </Modal>
        <Modal show={showDelete} onHide={handleCloseDelete}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Tick</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form> 
                <div>Are you sure you want to remove the most recent tick?</div>
                <Button variant="primary" disabled={deleteTickLoading} onClick={deleteTick}>
                    Detele Tick
                </Button>
                </Form>
            </Modal.Body>
        </Modal>
        </div>
    )
}

export default Ticks;